import { storage } from '@pichincha/angular-sdk/storage';
import { InjectionToken } from '@angular/core';
import { EventBusService } from '@pichincha/angular-sdk/eventbus';

const INTERCEPTOR_CONFIG_STORAGE = new InjectionToken('INTERCEPTOR_CONFIG_STORAGE');
const INTERCEPTOR_TIMER_EVENTS = new InjectionToken('INTERCEPTOR_TIMER_EVENTS');

/**
 * @context Injector angular
 */
function setAuthorization(data) {
    const $this = this;
    const config = $this.get(INTERCEPTOR_CONFIG_STORAGE);
    const instance = storage(config);
    const access_token = instance.get('access_token');
    const auth_token = instance.get('auth_token');
    const api_key = instance.get('api_key');
    let others = {};
    if (instance.get('others')) {
        Object.keys(instance.get('others')).map((key) => {
            others = { ...others, [key]: instance.get('others')[key] };
        });
    }
    let obj = {};
    obj = access_token
        ? Object.assign(obj, { Authorization: 'Bearer ' + access_token })
        : obj;
    obj = auth_token ? Object.assign(obj, { 'x-auth-token': auth_token }) : obj;
    obj = api_key ? Object.assign(obj, { 'x-api-key': api_key }) : obj;
    obj = others ? { ...obj, ...others } : obj;
    data.headers = { ...data.headers, ...obj };
    return data;
}

/**
 * restartTimer
 *
 * @description Funcion para ser usada por interceptor del response
 * del modulo http. Su funcion sera el de emitir un evento despues de cada
 * response exitoso, emitir un evento para que la shell reiniciar el timer
 * de sesion
 * @context Injector angular
 *
 */
function restartTimer(data) {
    const $this = this;
    const config = $this.get(INTERCEPTOR_TIMER_EVENTS, null);
    const event = $this.get(EventBusService, null);
    if (event && config) {
        event.emit(config.channel, config.topic, true);
    }
    return data;
}

/**
 * Generated bundle index. Do not edit.
 */

export { INTERCEPTOR_CONFIG_STORAGE, INTERCEPTOR_TIMER_EVENTS, restartTimer, setAuthorization };
